import React from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";

const ProductsTable = props => {
  const { products } = props;

  return (
    <TableContainer component={Paper}>
      <table className="table table-striped">
        <thead>
          <tr>
            <th className="text-center align-middle">SKU</th>
            <th className="text-center align-middle">Descripción</th>
            <th className="text-center align-middle">Cantidad solicitud</th>
            <th className="text-center align-middle">Cantidad recepción</th>
            <th className="text-center align-middle">Cantidad restante</th>
            <th className="text-center align-middle">Estado recepción</th>
          </tr>
        </thead>
        <tbody>
          {products.map(product => (
            <tr key={product.id}>
              <td className="text-center align-middle">
                {product.id_insumo_medicamento.SKU}
              </td>
              <td className="text-center align-middle">
                {product.id_insumo_medicamento.descripcion_producto}
              </td>
              <td className="text-center align-middle">
                {product.cantidad_solicitud}
              </td>
              <td className="text-center align-middle">
                {product.cantidad_recepcion}
              </td>
              <td className="text-center align-middle">
                {product.cantidad_restante}
              </td>
              <td className="text-center align-middle">
                {product.estado_recepcion}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainer>
  );
};

export default ProductsTable;

ProductsTable.propTypes = {
  products: PropTypes.array
};
